import { Component } from '@grafikr/components';

import clear from 'utils/clear';

export default Component((node, { app, dispatchEvent }) => {
  const { sectionId } = node.dataset;

  const initTriggers = () => {
    const filterButtons = [...node.querySelectorAll<HTMLButtonElement>('[data-filter]')];
    const sliderList = node.querySelector<HTMLElement>('.splide .splide__list');

    filterButtons.forEach((button) => {
      const { filter } = button.dataset;

      button.addEventListener('click', () => {
        filterButtons.forEach((element) => element.classList.remove('is-active'));
        button.classList.add('is-active');

        const template = node.querySelector<HTMLTemplateElement>(
          `template[data-template="${filter}"]`,
        );

        if (template) {
          node.classList.add('has-filtered');
          clear(sliderList);

          const clone = template.content.cloneNode(true);
          sliderList.appendChild(clone);

          dispatchEvent('carousel:update', {
            id: `carousel-${sectionId}`,
          });

          app.mount();
        }
      });
    });
  };

  initTriggers();
});
